var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscussionBubbles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_6362_29269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 7.91667C16.9779 4.11292 13.615 1.25 9.58333 1.25C4.98083 1.25 1.25 4.98083 1.25 9.58333C1.25 11.165 1.69083 12.6438 2.45583 13.9038C2.08458 14.7942 1.70667 15.8467 1.465 16.8142C1.32958 17.3571 1.80583 17.8146 2.345 17.665C3.27958 17.4054 4.30792 17.0275 5.19417 16.6683C6.03028 17.1876 6.95216 17.5539 7.91667 17.75",
    stroke: "#8080FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.75C8.75 10.9888 10.9888 8.75 13.75 8.75C16.5112 8.75 18.75 10.9888 18.75 13.75C18.75 14.7096 18.48 15.6058 18.0113 16.3667C18.1908 16.7467 18.3696 17.1838 18.5112 17.6525C18.6725 18.1883 18.1925 18.6488 17.6608 18.475C17.2362 18.3341 16.8197 18.1696 16.4133 17.9825C15.6162 18.4855 14.6926 18.7516 13.75 18.75C10.9888 18.75 8.75 16.5113 8.75 13.75Z",
    stroke: "#8080FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6362_29269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussionBubbles);
export default __webpack_public_path__ + "static/media/discussion-bubbles.6a3d0398ee38b75c8103409abd31ab24.svg";
export { ForwardRef as ReactComponent };